// 🔎 B242 (AI_112) — BUSCA EM CONSULTAS (evoluções) por termo + período (puro).
// Usado SÓ pela Busca Avançada (visão clínica identificada, médico-only): decide
// se um paciente tem alguma CONSULTA cujo texto contém o termo DENTRO do período.
// O período refere-se à DATA DA CONSULTA onde o termo aparece (pedido de Leonardo).
import { normalizarDataParaISO } from "../../ia-analise/services/anonimizarDados";

// Campos de texto livre de uma evolução onde o termo pode aparecer.
const CAMPOS_TEXTO_EVO = [
  "queixaPrincipal",
  "historiaDoencaAtual",
  "revisaoSistemas",
  "exameFisico",
  "hipotesesDiagnosticas",
  "conduta",
  "observacoes",
  "evolucaoLivre",
];

export interface EvolucaoBusca {
  data?: string;
  [campo: string]: unknown;
}

function norm(v: unknown): string {
  return String(v ?? "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .trim()
    .toLowerCase();
}

// Uma evolução contém o termo (já normalizado) em algum campo de texto?
export function evolucaoContemTermo(ev: EvolucaoBusca, termoNorm: string): boolean {
  if (!termoNorm) return true; // sem termo = qualquer evolução serve
  return CAMPOS_TEXTO_EVO.some((c) => norm(ev[c]).includes(termoNorm));
}

/**
 * O paciente tem ALGUMA consulta que satisfaz o termo E o período?
 * - termo vazio → só o período conta (qualquer consulta na janela).
 * - período vazio → só o termo conta (qualquer data).
 * - ambos → consulta com o termo cuja data caia na janela.
 * `iniISO`/`fimISO` em "YYYY-MM-DD" (inclusivos); "" = sem limite.
 */
export function temConsultaComTermoNoPeriodo(
  evolucoes: EvolucaoBusca[] | undefined,
  termo: string,
  iniISO: string,
  fimISO: string
): boolean {
  if (!evolucoes || evolucoes.length === 0) return false;
  const t = norm(termo);
  return evolucoes.some((ev) => {
    if (!evolucaoContemTermo(ev, t)) return false;
    if (iniISO || fimISO) {
      const d = normalizarDataParaISO(ev.data);
      if (!d) return false; // sem data não pode entrar num recorte por período
      if (iniISO && d < iniISO) return false;
      if (fimISO && d > fimISO) return false;
    }
    return true;
  });
}
